import { render, staticRenderFns } from "./wechatBasicInfo.vue?vue&type=template&id=3ebfde9a&scoped=true"
import script from "./wechatBasicInfo.vue?vue&type=script&lang=js"
export * from "./wechatBasicInfo.vue?vue&type=script&lang=js"
import style0 from "./wechatBasicInfo.vue?vue&type=style&index=0&id=3ebfde9a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ebfde9a",
  null
  
)

export default component.exports